import { render, staticRenderFns } from "./RelativeEditSlidebar.vue?vue&type=template&id=03c19899"
import script from "./RelativeEditSlidebar.vue?vue&type=script&lang=js"
export * from "./RelativeEditSlidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports